
const state = {
  base_price: undefined,
  campaign_quote_template_id: undefined,
  campaign_quote_template_section_id: undefined,
  compulsory: false,
  data: {
    agency_price: undefined,
    default_quote_item_id: undefined,
    hidden: false,
    publication_week: undefined,
    tags: [],
  },
  description: '',
  display_title: '',
  id: undefined,
  internal_notes: undefined,
  item_type: undefined,
  locked: false,
  options: undefined,
  options_string: undefined,
  order_bundle_id: undefined,
  package_id: undefined,
  price: '',
  price_type: 'fixed',
  price_override: '',
  processing_fee: undefined,
  provider_id: undefined,
  provider_price_list_item_id: undefined,
  publication_edition_id: undefined,
  publication_id: undefined,
  publication_package_id: undefined,
  quantity: undefined,
  required_by: undefined,
  required_days_from_start: undefined,
  row_title: undefined,
  selected: true,
  service_id: undefined,
  service_product_id: undefined,
  sort: undefined,
  title: undefined,
}

export const requiredFields = [
  { key: 'campaign_quote_template_id' },
  { key: 'campaign_quote_template_section_id' },
  { key: 'price', validation: (price: string) => price !== '' && !Number.isNaN(Number(price)) },
  { key: 'title' },
]

export default state
